// lib/mixpanelClient.ts
import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;
// const MIXPANEL_TOKEN = "";

let isInitialized = false;

export const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    if (process.env.NODE_ENV === "development") {
      console.warn("❗ Mixpanel token is missing! Check your .env file.");
    }
    return;
  }

  if (!isInitialized) {
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: process.env.NODE_ENV === "development",
      autocapture: true,
    });
    isInitialized = true;
  }
};

export const identifyUser = (userId: string) => {
  if (isInitialized && userId) {
    mixpanel.identify(userId);
  } else {
    console.warn("❌ Cannot identify user - Mixpanel not initialized or userId missing");
  }
};

export const setUserProfile = (userData: {
  $name?: string;
  $email?: string;
  role?: string;
  userId?: string;
  [key: string]: any;
}) => {
  if (isInitialized) {
    try {
      // Set user properties
      mixpanel.people.set(userData);
    } catch (error) {
      console.error("❌ Error setting user profile:", error);
    }
  }
};

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (isInitialized) {
    try {
      mixpanel.track(eventName, properties);
    } catch (error) {
      console.error("❌ Error tracking event:", error);
    }
  }
};
